import {validateBarriers, validateGrowthType} from '../_common/utils'
export const companyValidation = {
  mandatory, checkMarketCap, emptyAndLengthValidate, maxLengthValidate, validateMapKeys
}
export const headerArr = ['name','industryName','sectorName','industryName','exchangeName','ticker','barriers','financialStrength','momentum','topNewsBuy','dividendLeader','sociallyResponsible','watchlist','intersection','underValued']

function emptyAndLengthValidate(data,name){
  if(!data){
    return name+' is required'
  }
  return maxLengthValidate(data,256)
}

function maxLengthValidate(data,length){
  if(!length)
    length=256
  if(data && data.length>length){
    return 'Should be less than or equal to '+length.toString()+' chars'
  }
  return ''
}

function validateMapKeys(data,name){
  const result=(data !=null && data !=='') ? maxLengthValidate(data,3):''
  if(data !=null && data !=='' && name !=='GrowthType' && !validateBarriers(data)){
    return 'Enter valid data' // name +' value mismatched'
  }
  if(data !== null && data !=='' && name ==='GrowthType' && !validateGrowthType(data)){
    return 'Enter valid data' //'Growth Type is invalid'
  }
  return result
}

function mandatory(company,option) {
  const errors = {}
  if (!company.name) {
    errors.name = 'Company Name is required'
  }
  if(option === 1){
    if(company.sectorId <= 0){
      errors.sectorName = 'Sector is required'
    }
    if(company.industryId <= 0){
      errors.industryName = 'Industry is required'
    }
  }
  if(option===2){
    if(!company.sectorName){
      errors.sectorName = 'Sector is required'
    }
    if(!company.industryName){
      errors.industryName = 'Industry is required'
    }
  }
  if(option ===3){
    if(null !=company.sector && company.sector.id<=0){
      errors.sectorName = 'Sector is required'
    }
    if(null != company.industry && company.industry.id<=0){
      errors.industryName = 'Industry is required'
    }
  }
 
  headerArr.map(element => {
    switch(element){
    case'sectorName':
    case 'industryName':
    case 'exchangeName':
    case 'name':
      if(company[element] && company[element].length > 256)
        errors[element] = 'Should be less than 256 chars'
      break
    case 'ticker':
      if(company[element] && company[element].length > 15)
        errors[element] = 'Should be less than 15 chars'
      break
    case 'barriers':
    case 'financialStrength':
    case 'momentum':
    case 'topNewsBuy':
    case 'dividendLeader':
    case 'sociallyResponsible':
    case 'watchlist':
    case 'intersection':
    case 'underValued':
      if(company[element] && company[element].length > 3)
        errors[element] = 'Should be less than 3 chars'
      break
    default:
      break
    }
    if (!validateBarriers(company[element])) {
      switch(element){
      case 'barriers':
        errors.barriers = 'Barriers value mismatched'
        break
      case 'financialStrength':
        errors.financialStrength = 'Financial Strength value mismatched'
        break
      case 'momentum':
        errors.momentum = 'Momentum value mismatched'
        break
      case 'topNewsBuy':
        errors.topNewsBuy = 'TopNewsBuy value mismatched'
        break
      case 'dividendLeader':
        errors.dividendLeader = 'DividendLeader value mismatched'
        break
      case 'sociallyResponsible':
        errors.sociallyResponsible = 'SociallyResponsible value mismatched'
        break
      case 'watchlist':
        errors.watchlist = 'Watchlist value mismatched'
        break
      case'intersection':
        errors.intersection = 'Intersection value mismatched'
        break
      case 'underValued':
        errors.underValued = 'UnderValued value mismatched'
        break
      default:
        break
      }
    } 
    return element

  })

  if(!validateGrowthType(company.growthType)){
    errors.growthType = 'Growth Type value mismatched'
  }
  return errors
}


function checkMarketCap(value){
  let numberOnly = ''
  if (value && value.length > 0) {
    numberOnly = value.split(',').join('')
    if (!isNaN(numberOnly)){
      return numberOnly
    }
  }
  return 0
}
